import { makeObservable, observable, action } from "mobx";

import { transactionsController } from "../api/controllers/transactions";
import { DEFAULT_RESPONSE_LIST } from "../constants";
import { HttpResponse } from "../api";
import { RootStore } from ".";
import {
  BalanceRequestData,
  BalanceMonitoringParams,
  BalanceMonitoringResponse,
  BalanceTransactionRequestParams,
  BalanceTransactionRequestsResponse,
} from "../models";

export class TransactionsStore {
  private rootStore?: RootStore;

  public balanceRequestList = new HttpResponse<BalanceTransactionRequestsResponse>(DEFAULT_RESPONSE_LIST);

  public balanceMonitoringList = new HttpResponse<BalanceMonitoringResponse>(DEFAULT_RESPONSE_LIST);

  constructor(rootStore?: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      balanceRequestList: observable,
      balanceMonitoringList: observable,
      setBalanceRequestList: action.bound,
      setBalanceMonitoringList: action.bound,
    });
  }

  public async balanceRequestApproveOrReject(data: BalanceRequestData): Promise<any> {
    return await transactionsController.balanceRequestApproveOrReject(data);
  }

  public setBalanceRequestList(data: HttpResponse<BalanceTransactionRequestsResponse>): void {
    this.balanceRequestList = data;
  }

  public setBalanceMonitoringList(data: HttpResponse<BalanceMonitoringResponse>): void {
    this.balanceMonitoringList = data;
  }

  public async getBalanceRequestList(params: BalanceTransactionRequestParams): Promise<void> {
    this.setBalanceRequestList(this.balanceRequestList.fetching());
    const result = await transactionsController.getBalanceTransactionRequests(params);
    this.setBalanceRequestList(this.balanceRequestList.fetched(result));
  }

  public async getBalanceMonitoringList(params: BalanceMonitoringParams): Promise<void> {
    this.setBalanceMonitoringList(this.balanceMonitoringList.fetching());
    const result = await transactionsController.getBalanceMonitoringTransactions(params);
    this.setBalanceMonitoringList(this.balanceMonitoringList.fetched(result));
  }

  public resetBalanceRequestList(): void {
    this.setBalanceRequestList(this.balanceRequestList.fetched(DEFAULT_RESPONSE_LIST));
  }

  public resetBalanceMonitoringList(): void {
    this.setBalanceMonitoringList(this.balanceMonitoringList.fetched(DEFAULT_RESPONSE_LIST));
  }

}